
import { Component } from 'vue-property-decorator';
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';
import OutletPriceAddEdit from './OutletPriceAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class OutletPriceItem {
  id: string = '';
  outletCode: string = '';
  orderType: string = '';
  priceType: string = '';
}

@Component({
  components: {
    editor: OutletPriceAddEdit
  }
})
export default class OutletPriceList extends RemoteDataTable<OutletPriceItem> {
  public pageTitle: string = 'Outlet Price List';

  public newButtonText: string = 'New OutletPrice';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'orderType', label: 'Order Type' }),
    new RemoteDataField({ key: 'priceType', label: 'Price Type' })
  ];

  // to get page data
  get items(): OutletPriceItem[] {
    return this.$store.getters.GetAllOutletPrice;
  }

  get paging(): OutletPriceItem[] {
    return this.$store.getters.PagingOutletPrice;
  }

  get sorting(): OutletPriceItem[] {
    return this.$store.getters.SortingOutletPrice;
  }

  get filtering(): OutletPriceItem[] {
    return this.$store.getters.FilteringOutletPrice;
  }

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' });
  }

  resetFilter() {
    this.filterChanged(true);
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingOutletPrice', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringOutletPrice', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.outletPrice.pagingOutletPrice.page = 1;
    }
    this.$store.dispatch('GetAllOutletPrice');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteOutletPrice', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.outletPrice.pagingOutletPrice.size = page;
    this.$store.dispatch('GetAllOutletPrice');
  }
}
